/**
 * Where a context menu opens: at the pointer, flipped to the pointer's left
 * or above it when it would otherwise run off the window, as native menus do.
 */

export interface Size {
  readonly width: number;
  readonly height: number;
}

export function contextMenuPosition(
  at: { readonly x: number; readonly y: number },
  menu: Size,
  window: Size,
): { left: number; top: number } {
  const left = at.x + menu.width > window.width ? at.x - menu.width : at.x;
  const top = at.y + menu.height > window.height ? at.y - menu.height : at.y;
  return { left: Math.max(0, left), top: Math.max(0, top) };
}
